'use client';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Link, Typography, type TypographyProps } from '@mui/material';
import { DisclosureTooltip } from '../../DisclosureTooltip';

export type RatingTooltipProps = {
  starRatingTooltip: string;
  paddingY?: string;
  paddingX?: string;
  maxWidth?: string;
  tooltipSize?: string;
  tooltipColor?: string;
  textComponentType?: TypographyProps['component'];
};

export function RatingTooltip({
  starRatingTooltip,
  paddingY,
  paddingX,
  maxWidth,
  tooltipSize = '0.813rem',
  tooltipColor = 'black',
  textComponentType,
}: RatingTooltipProps) {
  return (
    <DisclosureTooltip
      placement="top"
      tooltipStyleOverride={{
        maxWidth: maxWidth ?? '340px',
        paddingY: paddingY ?? 1.5,
        paddingX: paddingX ?? 2,
      }}
      trigger={
        <Link
          aria-label="NerdWallet rating info"
          component="button"
          color="text.primary"
          variant="textSmall"
        >
          <HelpOutlineIcon
            className="HelpOutlineIcon"
            sx={{ fontSize: tooltipSize, color: tooltipColor }}
          />
        </Link>
      }
    >
      <Typography variant="textSmall" component={textComponentType ?? 'span'}>
        {starRatingTooltip}
      </Typography>
    </DisclosureTooltip>
  );
}
